module.exports = __webpack_public_path__ + "media/images/payment_methods/giftcard-5e62d0b7529637cb964a05bdb52de6d4.svg";